<template>
  <el-dialog
    append-to-body
    width="500px"
    title="批量设置搜索关键字"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      class="staff-from"
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="100px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
    >
      <el-form-item label="已选"> {{ list.length }}个 </el-form-item>
      <el-form-item label="关键词一">
        <el-input
          v-model.trim="form.data.keyword[0]"
          placeholder="请输入姓名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="关键词二">
        <el-input
          v-model.trim="form.data.keyword[1]"
          maxlength="11"
          placeholder="请输入电话"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="关键词三">
        <el-input
          v-model.trim="form.data.keyword[2]"
          maxlength="11"
          placeholder="请输入电话"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      list: [],
      form: {
        loading: false,
        data: {
          keyword: [],
        },
        rules: {},
      },
      areaArr: [],
      roleArr: [],
    };
  },
  methods: {
    getDetail(list) {
      this.list = list;
    },
    reset(done) {
      this.form.data = { keyword: [] };
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      if(this.form.data.keyword && this.form.data.keyword.join(',')){
        let obj = {
          ids: this.list.map(item => item.id).join('|'),
          keyword: this.form.data.keyword
        }
        this.form.loading = true;
        this.$http
        .post("/admin/goods/patchkeyword", obj).then(res =>{
          if(res.code ==1){
            this.$message.success('设置成功')
            this.$emit('update')
            this.toggle(false)
          }
        }).finally(() =>{
          this.form.loading = false;
        })
      }else {
        this.$message.warning('至少输入一个关键字');
      }
    },
  },
};
</script>
